import { Spin } from 'antd'
import React from 'react'

const TableLoadingOverlay: React.FC = () => <Spin />

export default TableLoadingOverlay
